"use client";

import Image from "next/image";
import { twMerge } from "tailwind-merge";

import Icon from "@/components/icon";
import { useModalStore } from "@/stores/modal-store";

import { DeleteTestimony } from "./delete-testimony";
import { SendTestimony } from "./send-testimony";

interface TestimonyCardProps {
  testimony: {
    description: string;
    witness: {
      civility: string;
      firstName: string;
      lastName: string;
      fullName: string;
      jobTitle: string;
      createdAt: string;
      updatedAt: string;
      id: string;
      avatar: {
        urls: {
          avatar_sm: string;
          avatar_md: string;
          avatar_lg: string;
        };
      };
    };
    id: string;
  };
  isPresident: boolean;
}

export const TestimonyCard = ({
  testimony,
  isPresident,
}: TestimonyCardProps) => {
  return (
    <div
      key={testimony.id}
      style={{
        border: "1px solid #000",
        padding: "10px",
        borderRadius: "10px",
        marginBottom: "10px",
        width: "350px",
        maxWidth: "350px",
        height: "auto",
        maxHeight: "550px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
        textAlign: "center",
        backgroundColor: "#fff",
      }}
    >
      <div className="flex justify-center items-center">
        <div
          style={{
            width: "70px",
            height: "70px",
            borderRadius: "50%",
            backgroundColor: "#000000",
            color: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize: "20px",
            fontWeight: "bold",
          }}
        >
          {testimony.witness.avatar ? (
            <Image
              src={testimony.witness.avatar.urls.avatar_md}
              alt="avatar"
              style={{ width: "100%", height: "100%", objectFit: "cover" }}
              width={70}
              height={70}
              className="rounded-full"
              unoptimized
              quality={100}
            />
          ) : (
            testimony.witness.firstName[0] + testimony.witness.lastName[0]
          )}
        </div>
        <div
          style={{
            marginLeft: "15px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <h4 style={{ fontSize: "16px", fontWeight: "bold" }}>
            {testimony.witness.fullName}
          </h4>
          <p style={{ fontSize: "12px", color: "#666" }}>
            {testimony.witness.jobTitle}
          </p>
        </div>
      </div>
      <div
        style={{
          width: "100%",
          height: "100%",
          color: "#000000",
          padding: "10px",
          borderRadius: "10px",
          marginTop: "10px",
          fontSize: "14px",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <Icon
          icon="testimonial-up"
          size={20}
          className={`mb-2 text-primary cursor-pointer`}
        />
        <p
          style={{
            fontSize: "14px",
            color: "#000000",
            overflowY: "auto",
            overflowX: "hidden",
            width: "100%",
            height: "100%",
            maxHeight: "355px",
            padding: "10px",
            marginBottom: "10px",
            borderRadius: "10px",
            wordWrap: "break-word",
            wordBreak: "break-word",
            whiteSpace: "pre-wrap",
          }}
        >
          {testimony.description}
        </p>
        {isPresident && (
          <div className="flex items-center justify-center gap-3">
            <div
              onClick={() => {
                useModalStore.getState().open({
                  component: (
                    <SendTestimony
                      testimony={testimony}
                      members={testimony.witness.fullName}
                      toBeUpdated={true}
                      closeModal={() => {
                        useModalStore.getState().close();
                      }}
                    />
                  ),
                });
              }}
              className={twMerge(
                "bg-white text-secondary hover:bg-secondary hover:text-white rounded-full h-10 flex items-center justify-center cursor-pointer w-10 border-2 border-secondary",
              )}
            >
              <Icon icon={"meeting-modif"} size={18} />
            </div>
            <div
              onClick={() => {
                useModalStore.getState().open({
                  component: (
                    <DeleteTestimony
                      testimony={testimony}
                      closeModal={() => {
                        useModalStore.getState().close();
                      }}
                    />
                  ),
                });
              }}
              className={twMerge(
                "bg-white text-primary hover:bg-primary hover:text-white rounded-full h-10 flex items-center justify-center cursor-pointer w-10 border-2 border-primary",
              )}
            >
              <Icon icon={"cross"} size={40} />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
